import React, { useContext, useEffect, useState, useMemo } from "react";
import { GetCookie, send, TOKEN_NAME } from "../components";
import { LoadingSpin } from "../components/ui/LoadingSpin";
import { isPartnerUser } from "../lib/authRoutes";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

const initialAuth = { user: null, loading: true, server_ip: "", txn_date: "" };

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(initialAuth);

  const setUser = (user) => {
    setAuth((prev) => ({
      ...prev,
      user,
      loading: false,
    }));
  };

  const isAuth = () => {
    return !!auth?.user && !!GetCookie(TOKEN_NAME);
  };

  useEffect(() => {
    async function checkUser() {
      const token = GetCookie(TOKEN_NAME);
      if (!token) {
        setAuth({ ...initialAuth, loading: false });
        return;
      }

      const res = await send("io0003", {});
      if (res.status !== "error") {
        // io0003 чинь юу буцаадаг нь тодорхойгүй тул 2 хувилбарын аль нэг:
        // A) res.user дотор user байвал:
        const userObj = res.user ?? res;

        setAuth((prev) => ({
          ...prev,
          user: userObj,
          loading: false,
          server_ip: res.server_ip ?? prev.server_ip,
          txn_date: res.txn_date ?? prev.txn_date,
          token_time: res.token_time,
        }));

        if (userObj?.userid) localStorage.setItem("PAYLINK_LOGINUSER", userObj.userid);
        if (res.token_time) localStorage.setItem("PayLinkTokenTime", res.token_time);

        if (!isPartnerUser(userObj) && userObj.status === 0) {
          // navigate('/verify-account');
          const path = window.location.pathname;
          // if (path !== '/verify-account') {
          //   window.location = '/verify-account';
          // }

          if (path !== '/dan-auth' && path !== '/verify-account') {
            window.location.replace('/dan-auth');
          }
        }
      } else {
        setAuth({ ...initialAuth, loading: false });
      }
    }

    checkUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const value = useMemo(
    () => ({ auth, user: auth.user, setUser, setAuth, isAuth }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [auth]
  );

  return (
    <AuthContext.Provider value={value}>
      {auth.loading ? <LoadingSpin /> : children}
    </AuthContext.Provider>
  );
}

export default AuthContext;
